import { render, staticRenderFns } from "./AmendmentDocumentRow.vue?vue&type=template&id=c3da52c8&scoped=true"
import script from "./AmendmentDocumentRow.vue?vue&type=script&lang=js"
export * from "./AmendmentDocumentRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3da52c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3da52c8')) {
      api.createRecord('c3da52c8', component.options)
    } else {
      api.reload('c3da52c8', component.options)
    }
    module.hot.accept("./AmendmentDocumentRow.vue?vue&type=template&id=c3da52c8&scoped=true", function () {
      api.rerender('c3da52c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/amendment/AmendmentDocumentRow.vue"
export default component.exports